import { picklesReducer } from 'src/app/travelxnew/store/reducers/pickles.reducer';
import { orientationsReducer } from 'src/app/travelxnew/store/reducers/orientations.reducer';

export const travelXNewReducers = {
    pickles: picklesReducer,
    orientations: orientationsReducer
};
